var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasExtencion('combos'))?_c('div',[_c('combos-modal'),_c('modal-button')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }